import type { FieldError } from 'react-hook-form';

interface ValidationMessageProps {
  error: FieldError | undefined;
  message: string;
  /** Show only when the error type matches this string. If omitted, shown whenever any error exists. */
  whenType?: string;
}

export function ValidationMessage({ error, message, whenType }: ValidationMessageProps) {
  if (!error) return null;
  if (whenType && error.type !== whenType) return null;
  return <p className="mt-1.5 text-xs text-hilevel-red">{message}</p>;
}
